const Tag = {
  sizes: {
    sm: {
      container: {
        px: '10px',
      },
    },
    md: {
      container: {
        px: '10px',
      },
    },
    lg: {
      container: {
        px: '16px',
      },
    },
  },
};

export default Tag;
